// extracted by mini-css-extract-plugin
module.exports = {"BrandBadge":"BrandBadge_BrandBadge__1lJ_x"};